<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-01 04:46:58
    Description : 素材详情页
  -->
  <div class="main">
    <div class="top">
      <div class="address page" v-if="type[contentType]">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/gaia-material/list' }">
            <span class="p">素材</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path: `/gaia-material/list?type=${contentType}` }"
          >
            <span class="p">{{ type[contentType].label }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="p">{{ material.title }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div
          class="donate-button"
          v-if="material.acceptDonations"
          @click="payVisible = true"
        >
          捐赠
        </div>
        <div
          class="donate-button"
          style="left: 1100px"
          @click="reportVisible = true"
        >
          举报/投诉
        </div>
      </div>
      <div class="address page" v-else>
        <div style="height: 14px"></div>
      </div>
      <div class="page-top page">
        <div
          class="left"
          v-if="['video', 'music', 'template'].includes(material.contentType)"
        >
          <gaia-player2
            :src="videoSrc"
            :audio="contentType === 'music'"
            @end="playEnd"
          />
        </div>
        <div
          class="left"
          v-else-if="['picture', 'other'].includes(contentType)"
        >
          <div v-if="contentType === 'picture'" style="height: 0">
            <div class="zoom-in-background">
              <div class="rotate" @click="imgViewerVisible = true">
                <zoom-in
                  class="zoom-in"
                  theme="outline"
                  size="38"
                  fill="#fff"
                />
              </div>
            </div>
          </div>
          <el-image class="picture" fit="cover" :src="imgUrl">
            <div slot="error">
              <div class="image-loading">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </el-image>
          <gaia-imgViewer2
            :xml="imgViewerDZI"
            :show="imgViewerVisible"
            @close="imgViewerVisible = false"
          />
        </div>
        <div class='left' v-else-if="material.contentType === 'virtualProperty'">
          <el-image v-if='imgUrl' class="picture" fit="cover" :src="imgUrl">
            <div slot="error">
              <div class="image-loading">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </el-image>
          <gaia-player2
            v-if='videoSrc'
            :src="videoSrc"
            @end="playEnd"
          />
        </div>
        <div class="left" v-else></div>
        <div class="right">
          <div class="right-page">
            <div class="title">
              <img
                class="title-icon"
                v-if="contentType"
                :src="type[contentType].icon"
              />
              <span style="font-weight: 700">{{ material.title }}</span>
            </div>
            <div class="time">
              发布于
              {{ $dayjs(material.createTime).format("YYYY-MM-DD hh:mm:ss") }}
            </div>
            <el-divider class="divider"></el-divider>
            <div class="user">
              <span
                style="cursor: pointer"
                @click="jumpTo(`/personal/index/${accountId}`)"
              >
                <el-avatar size="small" :src="avatar">
                  <img :src="process.env.VUE_APP_DEFAULTAVATAR" />
                </el-avatar>
              </span>
              <div class="nickname">
                {{ material.user ? material.user.nickname : "" }}
              </div>
              <member-tag :type="memberType" />
            </div>
            <div class="view-info" v-if="material.materialStatistics">
              <span>浏览：{{ material.materialStatistics.visitCount }}</span>
              <span style="margin: 0 4px"> | </span>
              <span>下载：{{ material.materialStatistics.downloadCount }}</span>
              <span style="margin: 0 4px"> | </span>
              <span>
                收藏：{{ material.materialStatistics.collectionCount }}
              </span>
              <span style="margin: 0 4px"> | </span>
              <span>分享：{{ material.materialStatistics.shareCount }}</span>
            </div>
            <el-divider class="divider"></el-divider>
            <div class="work-info">
              <div class="item" v-for="(item, i) in workInfo" :key="i">
                {{ i + item }}
              </div>
            </div>
            <div v-if="['video', 'music', 'picture'].includes(contentType)">
              <span class="more-info" @click="infoVisible = true">
                More info+
              </span>
            </div>
            <div class="video-list" v-if="contentType === 'video'">
              <el-divider class="divider mini"></el-divider>
              <el-scrollbar :vertical="true">
                <div
                  class="video-list-item"
                  v-for="(item, i) in videoList"
                  :key="i"
                  :class="{ checked: videoitemChecked === i }"
                  @click="videoListChange(i)"
                >
                  <div class="resolution">{{ item.resolution }}</div>
                  <div>{{ item.label }}</div>
                  <div style="font-size: 12px">
                    ¥{{ getPriceVal(item.price) }}
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
          <div class="btn-group">
            <div
              class="btn"
              v-if="selfAccountId == accountId"
              icon="el-icon-plus"
              @click="groupVisible = true"
            >
              <plus theme="filled" size="24" fill="#fff" />
            </div>
            <div class="btn" @click="shareVisible = true">
              <share theme="outline" size="24" fill="#fff" />
            </div>
            <div class="btn" @click="collect">
              <like
                :theme="isCollect ? 'filled' : 'outline'"
                size="24"
                :fill="isCollect ? '#ff484f' : '#fff'"
              />
            </div>
            <!-- <el-button
              :type="isCollect ? 'warning' : ''"
              icon="el-icon-star-off"
              @click="collect"
            ></el-button> -->
            <el-button
              v-show="displayPrice > 0"
              :loading="downLoading"
              type="primary"
              @click="addShoppingCart"
              :style="{ width: selfAccountId == accountId ? '125px' : '175px' }"
            >
              加入购物车
            </el-button>
            <el-button
              v-show="displayPrice <= 0"
              :loading="downLoading"
              type="primary"
              @click="downloadMaterial"
              :style="{ width: selfAccountId == accountId ? '125px' : '175px' }"
            >
              立即下载
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="group-dialog"
      title="加入小组"
      :visible.sync="groupVisible"
      width="500px"
    >
      <el-select
        v-model="groupModel"
        placeholder="请选择"
        style="width: 100%"
        size="small"
      >
        <el-option label="我加入的小组" value="1"> </el-option>
        <el-option label="我创建的小组" value="2"> </el-option>
      </el-select>
      <div class="group-list">
        <el-scrollbar v-show="groupModel == 1" style="height: 100%">
          <el-checkbox-group v-model="joinedSelect">
            <el-checkbox
              class="group-checkbox"
              v-for="(item, i) in joinedList"
              :key="i"
              :label="item.group.id"
            >
              {{ item.group.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>
        <el-scrollbar v-show="groupModel == 2" style="height: 100%">
          <el-checkbox-group v-model="createdSelect">
            <el-checkbox
              class="group-checkbox"
              v-for="(item, i) in createdList"
              :key="i"
              :label="item.id"
            >
              {{ item.name }}
              -
              {{ item.id }}
            </el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width: 320px" @click="addGroup">
          确定
        </el-button>
        <el-button plain @click="groupVisible = false" style="width: 130px">
          取消
        </el-button>
      </span>
    </el-dialog>
    <div class="center page">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="同主题推荐" name="同主题推荐">
          <div class="work-list">
            <el-scrollbar style="height: 100%">
              <div
                v-if="keywordList.length === 0"
                style="font-size: 12px; text-align: center; margin-top: 250px"
              >
                暂无推荐内容
              </div>
              <material-card
                v-for="(item, i) in keywordList"
                :key="i"
                :data="item"
                :showPrice="false"
                @click="cardClick(item.material.id, item.material.contentType)"
              />
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane label="同作者推荐" name="同作者推荐">
          <div class="work-list">
            <el-scrollbar style="height: 100%">
              <div
                v-if="creatorList.length === 0"
                style="font-size: 12px; text-align: center; margin-top: 250px"
              >
                暂无推荐内容
              </div>
              <material-card
                v-for="(item, i) in creatorList"
                :key="i"
                :data="item"
                :showPrice="false"
                @click="cardClick(item.material.id, item.material.contentType)"
              />
            </el-scrollbar>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-divider></el-divider>
      <div class="type">
        <span class="title">分类</span>
        <router-link
          v-for="(item, i) in tagList"
          :key="i"
          :to="`/gaia-material/list?title=${item}`"
        >
          <el-tag effect="plain" type="info" class="gaia-tag" :key="i">
            {{ item }}
          </el-tag>
        </router-link>
      </div>
      <el-divider></el-divider>
    </div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <div style="font-size: 24px">缘起</div>
      </div>
      <div class="text item" v-html="material.story">
        {{ material.story === "" ? "暂无内容" : "" }}
      </div>
    </el-card>
    <el-card class="box-card" shadow="never">
      <el-input
        type="textarea"
        placeholder="文明社区，理性发言..."
        v-model="commentVal"
        maxlength="200"
        show-word-limit
      >
      </el-input>
      <div style="margin: 20px 0; text-align: right">
        <el-button
          :loading="commentLoading"
          type="primary"
          style="width: 100px"
          @click="comment"
        >
          发表
        </el-button>
      </div>
      <div class="comment-list">
        <h3 style="padding-left: 18px">
          所有评论
          <span style="font-size: 14px"> {{ courseCommentList.length }}</span>
        </h3>
        <div
          v-if="courseCommentList.length === 0"
          style="text-align: center; margin: 50px 0 30px"
        >
          暂无评论
        </div>
        <div class="item" v-for="(item, i) in courseCommentList" :key="i">
          <div class="avatar">
            <el-avatar size="large" :src="baseUrl + item.user.avatar">
              <img :src="process.env.VUE_APP_DEFAULTAVATAR" />
            </el-avatar>
          </div>
          <div class="info">
            <div class="nickname">{{ item.user.nickname }}</div>
            <div class="content">{{ item.content }}</div>
            <div class="createTime">
              {{ $dayjs(item.createTime).format("YYYY-MM-DD hh:mm:ss") }}
            </div>
          </div>
          <div
            class="delete"
            v-if="selfUser && item.user.account.id == selfUser.account.id"
            @click="deleteComment(item.id)"
          >
            <delete theme="outline" size="18" />
            <div>删除</div>
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog
      title="详细信息"
      custom-class="material-upload"
      :visible.sync="infoVisible"
      width="700px"
    >
      <div class="title">文件概要</div>
      <div class="item">素材ID: {{ id }}</div>
      <div class="item">文件格式: {{ workInfo["格式："] }}</div>
      <div class="item">文件大小: {{ workInfo["大小："] }}</div>
      <div class="item">
        人像授权协议: {{ material.portraitureAgreement ? "有" : "无" }}
      </div>
      <div class="item">
        授权授权协议: {{ material.realrightAgreement ? "有" : "无" }}
      </div>
      <div class="title">素材信息</div>
      <div v-if="material.video && contentType === 'video'">
        <div class="item" style="width: 100%">
          视频编码: {{ material.video.videoInfo.codecLongName }}
        </div>
        <div class="item">视频帧率: {{ workInfo["帧率："] }}</div>
        <div class="item">
          像素格式: {{ material.video.videoInfo.pixelFormat }}
        </div>
        <div class="item">
          色彩空间: {{ material.video.videoInfo.colorSpace }}
        </div>
        <div class="item">
          视频时长: {{ getDate(material.video.videoInfo.duration) }}
        </div>
        <div class="item">画面比例: {{ material.video.videoInfo.dar }}</div>
      </div>
      <div v-if="material.video && contentType === 'picture'">
        <div class="item">通道数: {{ material.video.imageInfo.bands }}</div>
        <div class="item">数值编码: {{ material.video.imageInfo.coding }}</div>
        <div class="item">
          颜色空间: {{ material.video.imageInfo.interpretation }}
        </div>
        <div class="item">通道位深: {{ material.video.imageInfo.size }}bit</div>
        <div class="item">
          分辨率: {{ material.video.imageInfo.width }}
          ×
          {{ material.video.imageInfo.height }}
        </div>
      </div>
      <div v-if="material.video && contentType === 'music'">
        <div class="item">
          音频编解码名: {{ material.video.audioInfo.codecName }}
        </div>
        <div class="item" style="width: 66%">
          音频编解码全名: {{ material.video.audioInfo.codecLongName }}
        </div>
        <div class="item">比特率: {{ material.video.audioInfo.bitRate }}</div>
        <div class="item">
          位深度: {{ material.video.audioInfo.bits || "无" }}
        </div>
        <div class="item">
          声道布局: {{ material.video.audioInfo.channelLayout }}
        </div>
        <div class="item">
          声道数量: {{ material.video.audioInfo.channels }}
        </div>
        <div class="item">
          时长: {{ getDate(material.video.audioInfo.duration) }}
        </div>
        <div class="item">
          档次: {{ material.video.audioInfo.profile || "无" }}
        </div>
        <div class="item">
          样本格式: {{ material.video.audioInfo.sampleFormat }}
        </div>
        <div class="item">
          采样率: {{ material.video.audioInfo.sampleRate }}
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="分享"
      custom-class="material-upload"
      :visible.sync="shareVisible"
      width="700px"
    >
      <div class="title">分享链接</div>
      <el-input
        v-model="shareUrl"
        :readonly="true"
        style="margin-top: 10px"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-link"
        style="position: relative; top: -40px; left: 540px"
        @click="copyContent"
      >
        复制链接
      </el-button>
    </el-dialog>
    <el-dialog
      title="赞赏"
      custom-class="material-upload"
      :visible.sync="payVisible"
      width="580px"
    >
      <div class="donate-title">
        优质的原创作品离不开你的支持, 请作者喝杯咖啡吧!
      </div>
      <div class="donate-title2">捐赠金额</div>
      <div class="price">
        <div
          class="checkbox"
          :class="{ checked: donate === 0 }"
          @click="donate = 0"
        >
          5元
        </div>
        <div
          class="checkbox"
          :class="{ checked: donate === 1 }"
          @click="donate = 1"
        >
          10元
        </div>
        <div
          class="checkbox"
          :class="{ checked: donate === 2 }"
          @click="donate = 2"
        >
          20元
        </div>
        <div
          class="checkbox"
          :class="{ checked: donate === 3 }"
          @click="donate = 3"
        >
          50元
        </div>
        <div
          class="checkbox"
          :class="{ checked: donate === 4 }"
          @click="donate = 4"
        >
          100元
        </div>
        <div
          class="checkbox"
          :class="{ checked: donate === 5 }"
          @click="donate = 5"
        >
          其它
        </div>
      </div>
      <div v-show="donateOtherVisible" style="margin-top: 20px">
        <span> 捐赠金额 </span>
        <el-input
          v-model="donateMoney"
          size="mini"
          placeholder="请输入5-1000之间的整数"
          style="width: 100px"
        ></el-input>
      </div>
      <div style="margin-top: 20px; text-align: center">
        <el-button
          size="mini"
          type="primary"
          style="width: 110px"
          @click="payDonate"
        >
          捐赠
        </el-button>
        <el-button size="mini" @click="payVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="举报/投诉"
      custom-class="material-upload"
      :visible.sync="reportVisible"
      width="700px"
    >
      <div class="title">提交以下信息或通过在线客服及电话反馈您的问题！</div>
      <div class="report-info">
        举报/投诉对象：
        <span class="title">{{ material.title }}</span>
        原作者：
        <span> {{ material.user ? material.user.nickname : "" }}</span>
      </div>
      <div class="title" style="margin: 10px 0">请选择举报/投诉原因：</div>
      <el-checkbox-group v-model="reportForm.checkList">
        <el-checkbox label="含有违法内容">含有违法内容 </el-checkbox>
        <el-checkbox label="侵犯他人权益">侵犯他人权益 </el-checkbox>
        <el-checkbox label="内容低俗不健康"> 内容低俗不健康 </el-checkbox>
        <el-checkbox label="其他原因">其他原因 </el-checkbox>
      </el-checkbox-group>
      <el-input
        v-model="reportForm.reportContent"
        type="textarea"
        style="margin-top: 10px"
      ></el-input>

      <div style="margin-top: 20px; text-align: center">
        <el-button
          size="mini"
          type="primary"
          style="width: 110px"
          @click="reportConfirm"
        >
          提交信息
        </el-button>
        <el-button size="mini" @click="reportVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Delete, ZoomIn, Share, Plus, Like } from "@icon-park/vue";
import gaiaPlayer2 from "@/components/gaia-player/gaia-player2";
import gaiaImgViewer2 from "@/components/gaia-imgViewer/gaia-imgViewer2";
import materialCard from "@/components/work-card/material-card";
import MemberTag from "@/components/member-tag/member-tag";
import { getSize, secondToDate, copyContent } from "@/utils/utils";
import {
  getVideoDetail,
  getPictureDetail,
  getRecommend,
  getRecommend2,
  collect,
  comment,
  getCommentList,
  deleteComment,
  addShoppingCart,
  shareMaterial,
  createReport,
} from "@/api/material";
import {
  getJoinedList,
  getCreatedList,
  addMaterialToManyGroup,
} from "@/api/group";
import { downloadMaterial } from "@/api/upload";
import { acceptDonations } from "@/api/order";

export default {
  components: {
    Delete,
    ZoomIn,
    Share,
    Plus,
    Like,
    gaiaPlayer2,
    gaiaImgViewer2,
    materialCard,
    MemberTag,
  },
  data() {
    return {
      process: process,
      id: null,
      accountId: 0,
      selfAccountId: 0,
      contentType: "video",
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      selfUser: JSON.parse(localStorage.getItem("user")),
      allowDownload: false,
      activeName: "同主题推荐",
      videoSrc: "",
      workInfo: {},
      commentVal: "", // 评论内容
      commentLoading: false, // 评论按钮loading
      downLoading: false, // 下载/加购loading
      creatorList: [], // 同作者推荐
      keywordList: [], // 同主题推荐
      material: {}, // material对象
      isCollect: false, // 是否收藏
      avatar: "", // 作者头像
      memberType: "", // 作者会员等级
      videoList: [], // 视频分辨率列表
      videoitemChecked: 0,
      courseCommentList: [], // 评论列表
      joinedList: [], // 我加入的小组
      createdList: [], // 我管理的小组
      tagList: ["标签1", "标签2"],
      type: {
        video: {
          label: "视频素材",
          icon: require("@/assets/icon/video.png"),
        },
        picture: {
          label: "图片素材",
          icon: require("@/assets/icon/picture.png"),
        },
        music: {
          label: "音频素材",
          icon: require("@/assets/icon/music.png"),
        },
        template: {
          label: "模板素材",
          icon: require("@/assets/icon/template.png"),
        },
        virtualProperty: {
          label: '虚拟资产素材',
          icon: require("@/assets/icon/virtual.png"),
        },
        other: {
          label: "其它素材",
          icon: require("@/assets/icon/other.png"),
        },
      },
      imgViewerVisible: false,
      imgViewerDZI: "",
      imgUrl: "",
      portraitureAgreement: false,
      realrightAgreement: false,
      groupVisible: false, // 加入小组
      groupModel: "1",
      joinedSelect: [], // 选中的小组
      createdSelect: [],
      pageLoading: null,
      displayPrice: 0,
      priceList: {
        transcode2kDisPlayPrice: 0,
        transcode4kDisPlayPrice: 0,
        transcode8kDisPlayPrice: 0,
        transcode16kDisPlayPrice: 0,
      },
      infoVisible: false,
      shareVisible: false,
      payVisible: false,
      shareUrl: "",
      donate: 1,
      donateMoney: 0,
      donateOtherVisible: false,
      reportVisible: false, // 举报弹窗
      reportForm: {
        materialId: "",
        checkList: [],
        reportContent: "",
      },
    };
  },
  watch: {
    donate(new_value) {
      if (new_value === 5) {
        this.donateOtherVisible = true;
      } else {
        this.donateOtherVisible = false;
      }
    },
  },
  created() {
    const id = this.$route.params.id;
    const contentType = this.$route.query.contentType;
    this.id = id;
    this.selfAccountId = JSON.parse(localStorage.getItem("user")).account.id;
    this.contentType = contentType;
    if (contentType === "video") {
      this.getVideoDetail(id);
    } else {
      this.getPictureDetail(id);
    }
    // 同主题推荐
    getRecommend(id).then((res) => {
      this.creatorList = res.materialList;
    });
    // 同作者推荐
    getRecommend2(id).then((res) => {
      this.keywordList = res.materialList;
    });
    // 加载评论列表
    this.getCommentList();
    // 加载小组列表
    this.getGroupList();
    this.shareUrl = location.href;
  },
  beforeDestroy() {
    if (["video", "music", "template", "virtualProperty"].includes(this.contentType)) {
      window.myPlayer.dispose();
    }
  },
  methods: {
    getDate(time) {
      return secondToDate(time);
    },
    getPriceVal(price) {
      if (price === '-0.01') {
        return "免费";
      } else if (price === '-0.02') {
        return "已购买";
      } else if (price === '-0.03') {
        return "出售中";
      }
      return price;
    },
    videoListChange(i) {
      if (this.videoitemChecked != i) {
        if (i === 0) {
          this.displayPrice = this.material.displayPrice;
        } else {
          this.displayPrice = this.priceList[
            `${this.videoList[i].value}DisPlayPrice`
          ];
        }
      }
      this.videoitemChecked = i;
    },
    playEnd(ifDuration) {
      console.log("播放完毕");
    },
    showWorkInfo() {
      const material = this.material;
      const contentType = material.contentType;
      let list = {};
      if (contentType === "video") {
        list = {
          // "版本：": "4K源文件",
          "机型：": material.mworks.model || "无",
          "镜头：": material.mworks.lens || "无",
          "地点：": material.mworks.address || "无",
          "像素：": `${material.video.videoInfo.width}×${material.video.videoInfo.height}`,
          "帧率：": material.video.videoInfo.fps.toFixed(2),
          "格式：": material.video.videoInfo.codecName,
          "大小：": getSize(material.video.formatInfo.size),
        };
      } else if (contentType === "picture") {
        let width, height;
        material.video.resources.map((el) => {
          if (el.type === "HLS_AVC") {
            width = el.width;
            height = el.height;
          }
        });
        list = {
          "机型：": material.picture.model || "无",
          "镜头：": material.picture.lens || "无",
          "地点：": material.picture.address || "无",
          "像素：": `${width}×${height}`,
          "格式：": material.video.imageInfo.format || "无",
          "颜色模式：": material.video.imageInfo.interpretation || "无",
          "大小：": getSize(material.video.formatInfo.size),
          "人像授权协议：": `${this.portraitureAgreement ? "有" : "无"}`,
          "物权授权协议：": `${this.realrightAgreement ? "有" : "无"}`,
        };
      } else if (contentType === "music") {
        list = {
          "格式：": material.video.audioInfo.codecName,
          "大小：": getSize(material.video.formatInfo.size),
          "推荐软件：": material.music.software || "无",
          "人像授权协议：": `${this.portraitureAgreement ? "有" : "无"}`,
          "物权授权协议：": `${this.realrightAgreement ? "有" : "无"}`,
        };
      } else if (contentType === "other") {
        list = {
          "格式：": "MP3",
          "素材内容：": material.template.software || "无",
          "大小：": getSize(material.template.size),
          "人像授权协议：": `${this.portraitureAgreement ? "有" : "无"}`,
          "物权授权协议：": `${this.realrightAgreement ? "有" : "无"}`,
        };
      } else if (contentType === "template") {
        list = {
          "软件版本：": material.template.version,
          "格式：": "MP3",
          "文件大小：": getSize(material.video.formatInfo.size),
          "人像授权协议：": `${this.portraitureAgreement ? "有" : "无"}`,
          "物权授权协议：": `${this.realrightAgreement ? "有" : "无"}`,
        };
      } else if (contentType === "virtualProperty") {
        list = {
          "软件版本：": material.virtualProperty.software || "无",
          "格式：": material.virtualProperty.format || "无",
          "文件大小：": getSize(material.virtualProperty.size),
          "人像授权协议：": `${this.portraitureAgreement ? "有" : "无"}`,
          "物权授权协议：": `${this.realrightAgreement ? "有" : "无"}`,
        };
      }
      for (let i in list) {
        this.workInfo[i] = list[i];
      }
    },
    handleClick(tab, event) {},

    cardClick(i, contentType) {
      this.$router.push(
        `/gaia-material/detail/${i}?contentType=${contentType}`
      );
    },
    collect() {
      collect(this.id)
        .then((res) => {
          if (res.msg === "cancel.collection") {
            this.$message.success("取消收藏成功");
            this.isCollect = false;
          } else if (res.msg === "again.collection") {
            this.$message.success("收藏成功");
            this.isCollect = true;
          } else if (res.msg === "new.collection") {
            this.$message.success("收藏成功");
            this.isCollect = true;
          }
        })
        .catch((err) => {
          this.$message.error("收藏失败");
        });
    },
    comment() {
      if (this.commentVal === "") {
        this.$message.warning("评论内容不能为空");
        return;
      }
      this.commentLoading = true;
      comment({ id: this.id, content: this.commentVal })
        .then((res) => {
          // console.log(res);
          this.commentLoading = false;
          this.$message.success("评论成功");
          this.commentVal = "";
          this.getCommentList();
        })
        .catch((err) => {
          this.commentLoading = false;
          this.$message.error("评论失败");
        });
    },
    /**
     * 视频素材详情
     */
    getVideoDetail(id) {
      getVideoDetail(id)
        .then((res) => {
          this.material = res.material;
          this.memberType = res.memberType;
          this.allowDownload = res.material.allowDownload;
          this.avatar = this.baseUrl + res.material.user.avatar;
          this.showWorkInfo();
          this.isCollect = res.collect;
          this.accountId = res.material.user.account.id;
          res.material.video.resources.map((el) => {
            if (el.type === "HLS_AVC") {
              this.videoSrc = this.baseUrl + el.resourceKey;
            }
          });
          // 视频分辨率列表
          this.displayPrice = res.material.displayPrice;
          this.priceList.transcode2kDisPlayPrice = res.transcode2kDisPlayPrice;
          this.priceList.transcode4kDisPlayPrice = res.transcode4kDisPlayPrice;
          this.priceList.transcode8kDisPlayPrice = res.transcode8kDisPlayPrice;
          this.priceList.transcode16kDisPlayPrice = res.transcode16kDisPlayPrice;
          this.videoList = this.getVideoResourceList();
          this.tagList = res.material.keyword.split(";");
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取数据失败");
        });
    },
    /**
     * 图片 音频 模板 其它素材详情
     */
    getPictureDetail(id) {
      getPictureDetail(id)
        .then((res) => {
          this.material = res.material;
          this.memberType = res.memberType;
          this.allowDownload = res.material.allowDownload;
          this.avatar = this.baseUrl + res.material.user.avatar;
          this.displayPrice = res.material.displayPrice;
          this.showWorkInfo();
          this.isCollect = res.collect;
          const contentType = res.material.contentType;
          if (["picture", "music", "template"].includes(contentType)) {
            res.material.video.resources.map((el) => {
              if (contentType === "picture") {
                if (el.type === "HLS_AVC") {
                  this.imgViewerDZI = this.baseUrl + el.resourceKey;
                }
                if (el.type === "SCREENSHOT" && el.resourceName === "540") {
                  this.imgUrl = this.baseUrl + el.resourceKey;
                }
              } else if (["music", "template"].includes(contentType)) {
                // 音频 模板
                if (el.type === "HLS_AVC") {
                  this.videoSrc = this.baseUrl + el.resourceKey;
                }
              }
            });
          } else if (contentType === "other") {
            this.imgUrl = this.baseUrl + res.material.cover;
          } else if (contentType === "virtualProperty") {
            if (!res.material.video) {
              this.imgUrl = this.baseUrl + res.material.cover;
            } else {
              console.log(123)
              res.material.video.resources.map((el) => {
                if (el.type === "HLS_AVC") {
                  this.videoSrc = this.baseUrl + el.resourceKey;
                }
              })
            }
          }
          this.accountId = res.material.user.account.id;
          this.tagList = res.material.keyword.split(";");
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取数据失败");
        });
    },
    /**
     * 评论列表
     */
    getCommentList() {
      getCommentList(this.id)
        .then((res) => {
          if (res.code !== "success") {
            this.$message.error("获取评论列表失败");
          } else {
            this.courseCommentList = res.courseCommentList;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取评论列表失败");
        });
    },
    deleteComment(id) {
      this.$confirm("确认删除该评论？")
        .then((_) => {
          deleteComment(id)
            .then((res) => {
              this.$message.success("删除评论成功");
              this.getCommentList();
            })
            .catch((err) => {
              this.$message.error("删除评论失败");
            });
        })
        .catch((_) => {
          this.$message("操作已取消");
        });
    },
    getGroupList() {
      // 创作组列表
      getJoinedList()
        .then((res) => {
          if (res.code !== "success") {
            this.$message.error("获取创作组列表失败");
          } else {
            this.joinedList = res.myJoinGroupList;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取创作组列表失败");
        });
      getCreatedList()
        .then((res) => {
          if (res.code !== "success") {
            this.$message.error("获取创作组列表失败");
          } else {
            this.createdList = res.groups;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取创作组列表失败");
        });
    },
    addGroup() {
      let id = [];
      if (this.groupModel == 1) {
        id = this.joinedSelect;
      } else {
        id = this.createdSelect;
      }
      if (id.length === 0) {
        this.$message.warning("至少选择一个小组");
        return;
      }
      this.groupVisible = false;
      this.pageLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      addMaterialToManyGroup({
        groupIds: id,
        materialId: parseInt(this.id),
      })
        .then((res) => {
          this.pageLoading.close();
          this.$message.success("添加到小组成功");
        })
        .catch((err) => {
          console.log(err);
          this.pageLoading.close();
          this.$message.error("添加到小组失败");
        });
    },
    getResourceName() {
      const resolution = this.material.video.videoInfo.resolution;
      if (resolution >= 16) {
        return "transcode16k";
      } else if (resolution >= 8 && resolution < 16) {
        return "transcode8k";
      } else if (resolution >= 4 && resolution < 8) {
        return "transcode4k";
      } else if (resolution < 4) {
        return "transcode2k";
      }
    },
    /**
     * 获取视频分辨率以及转码列表
     */
    getVideoResourceList() {
      const resolution = this.material.video.videoInfo.resolution;
      let list = [
        {
          resolution: `16K`,
          label: "源文件",
          value: "origin",
          price: (this.displayPrice / 100).toFixed(2),
        },
      ];
      let into = false;
      if (resolution >= 16) {
        into = true;
        list.push({
          resolution: `16K`,
          label: "转码文件",
          value: "transcode8k",
          price: (this.priceList.transcode16kDisPlayPrice / 100).toFixed(2),
        });
      }
      if (resolution >= 8 && resolution < 16) {
        if (!into) {
          into = true;
          list[0].resolution = "8K";
        }
        list.push({
          resolution: `8K`,
          label: "转码文件",
          value: "transcode4k",
          price: (this.priceList.transcode8kDisPlayPrice / 100).toFixed(2),
        });
      }
      if (resolution >= 4 && resolution < 8) {
        if (!into) {
          into = true;
          list[0].resolution = "4K";
        }
        list.push({
          resolution: `4K`,
          label: "转码文件",
          value: "transcode4k",
          price: (this.priceList.transcode4kDisPlayPrice / 100).toFixed(2),
        });
      }
      if (!into) {
        list[0].resolution = "2K";
      }
      list.push({
        resolution: `2K`,
        label: "转码文件",
        value: "transcode2k",
        price: (this.priceList.transcode2kDisPlayPrice / 100).toFixed(2),
      });
      return list;
    },
    /**
     * 下载作品
     */
    downloadMaterial() {
      this.downLoading = true;
      let data = {
          colorEnhancement: 'nce',
          materialId: parseInt(this.id),
      };
      if (this.contentType === "video") {
        data.resourceName = this.getResourceName();
        data.resourceName = this.videoList[this.videoitemChecked].value;
      }
      downloadMaterial(data)
        .then((res) => {
          open(res.url);
          if (res.PoAgreementUrl) {
            open(res.PoAgreementUrl);
          }
          if (res.ReAgreementUrl) {
            open(res.ReAgreementUrl);
          }
          this.downLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.downLoading = false;
        });
    },
    /**
     * 加入购物车
     */
    addShoppingCart() {
      this.downLoading = true;
      addShoppingCart({
        materialId: parseInt(this.id),
        resolution: this.videoList[this.videoitemChecked]
          ? this.videoList[this.videoitemChecked].value
          : "origin",
      })
        .then((res) => {
          console.log(res);
          this.downLoading = false;
          if (res.subCode === "can.not.buy") {
            this.$message.error("不能购买自己的素材");
          } else {
            this.$message.success("加入购物车成功");
            this.$confirm("加入购物车成功，是否跳转到购物车结算？")
              .then((_) => {
                this.$router.push("/shopping-cart");
              })
              .catch((_) => {});
          }
        })
        .catch((err) => {
          console.log(err);
          this.downLoading = false;
          this.$message.error("加入购物车失败");
        });
    },
    /**
     * 非router跳转路由
     */
    jumpTo(url, self = false) {
      if (self) {
        location.href = url;
      } else {
        window.open(url);
      }
    },
    copyContent() {
      shareMaterial(this.id);
      if (copyContent(this.shareUrl)) {
        this.$message.success("复制成功");
      } else {
        this.$message.error("复制失败");
      }
    },
    /**
     * 捐赠素材
     */
    payDonate() {
      let price = 0;
      const list = [5, 10, 20, 50, 100];
      if (this.donate < 5) {
        price = list[this.donate];
      } else {
        price = this.donateMoney;
      }
      if (!(price >= 5 && price <= 1000)) {
        this.$message.error("价格必须在5-1000以内, 请重新输入");
        return;
      }
      const data = {
        id: Number(this.id),
        isMobile: false,
        payment: "alipay",
        price: parseInt(price) * 100,
        type: "material",
      };
      acceptDonations(data)
        .then((res) => {
          console.log(res);
          if (res.form) {
            document.write(res.form);
          } else {
            this.$message.error("捐赠订单创建失败");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("捐赠订单创建失败");
        });
    },
    reportConfirm(e) {
      if (this.reportForm.checkList.length === 0) {
        this.$message.error("请选择举报原因");
        return;
      }
      if (this.reportForm.checkList.includes("其他原因")) {
        if (this.reportForm.reportContent === "") {
          this.$message.error("请将其他原因填写完整");
          return;
        }
      }
      this.reportForm.materialId = this.material.id;
      const temp = {
        materialId: this.material.id,
        reportType: this.reportForm.checkList.join(" "),
        reportContent: this.reportForm.reportContent,
      };
      createReport(temp)
        .then((res) => {
          console.log(res);
          this.reportVisible = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less">
.material-upload {
  .el-dialog__header {
    border-bottom: 3px #ff4f57 solid;
    margin: 0 20px;
  }
}
</style>
<style lang="less" scoped>
@width: 1200px;
@min-width: 1300px;

.main {
  min-width: @min-width;
  background: #ededed;
  padding-bottom: 50px;
  overflow-x: hidden;
}

.top {
  padding: 120px 0 70px;
  background: #262a2d;
}

.donate-button {
  position: relative;
  top: -15px;
  left: 1174px;
  font-size: 12px;
  height: 0;
  color: #dcdcdc;
  cursor: pointer;
  // top:;
}
.donate-button:hover {
  color: #ffffff;
}

.address {
  margin-bottom: 26px;
  .p {
    font-size: 12px;
    color: #dcdcdc;
  }
}

.page-top {
  display: flex;
  width: @width;
  padding: 0;
  .left,
  .right {
    height: 506px;
  }
  .left {
    width: 900px;
    background: #999999;
    .picture {
      width: 100%;
      height: 100%;
    }
    .zoom-in {
      position: relative;
      left: -70px;
      top: -60px;
      z-index: 1000;
      cursor: pointer;
      pointer-events: auto;
    }
    .rotate {
      transform: rotate(45deg) !important;
    }
    .zoom-in-background {
      position: relative;
      display: inline-block;
      left: 800px;
      top: 407px;
      width: 0;
      height: 0;
      // padding: 50px;
      // background: rgba(0, 0, 0, 0.4);
      border: 100px solid transparent;
      border-top-color: rgba(0, 0, 0, 0.4);
      z-index: 1001;
      transform: rotate(-45deg);
      pointer-events: none;
    }
    .image-loading {
      width: 100%;
      height: 506px;
      background: #ffffff;
      text-align: center;
      font-size: 20px;
      i {
        margin-top: 25%;
      }
    }
  }
  .right {
    width: 285px;
    margin-left: 15px;
    .right-page {
      width: 285px;
      height: 446px;
      padding: 20px 20px 0;
      border-radius: 4px;
      background: #444444;
      color: #999999;
    }
    .title {
      font-size: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #ffffff;
      .title-icon {
        //width: 24px;
        height: 24px;
        margin-right: 6px;
      }
    }
    .time {
      font-size: 12px;
      padding-top: 14px;
    }
    .user {
      display: flex;
      .nickname {
        margin-left: 10px;
        font-size: 20px;
      }
    }
    .view-info {
      font-size: 12px;
      margin-top: 10px;
      padding-left: 0px;
    }
    .work-info {
      .item {
        display: inline-block;
        width: 50%;
        font-size: 12px;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }
    }
    .video-list-item {
      display: inline-block;
      width: 74px;
      height: 74px;
      border-radius: 6px;
      margin: 0 4px;
      padding: 8px 8px 0;
      font-size: 14px;
      // text-align: center;
      background: #999999;
      color: #ffffff;
      transition: all 0.3s;
      user-select: none;
      cursor: pointer;
      .resolution {
        font-size: 16px;
      }
    }
    .video-list-item.checked {
      background: #4b6efa;
      transition: all 0.3s;
    }
    .btn-group {
      margin-top: 20px;
      white-space: nowrap;
      .btn {
        display: inline-block;
        width: 40px;
        height: 40px;
        padding-top: 8px;
        margin-right: 10px;
        border-radius: 6px;
        background: #444444;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .more-info {
      font-size: 12px;
      color: #4b6efa;
      user-select: none;
      cursor: pointer;
    }
  }
}

.group-list {
  width: 100%;
  height: 160px;
  margin: 20px 0;
  border: 1px solid#dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  .group-checkbox {
    display: block;
    margin: 10px 20px;
  }
}

.center {
  margin-top: 20px;
  .work-list {
    height: 520px;
    .item {
      margin: 10px 0.4% 30px 0.5%;
    }
    .item:nth-child(4n) {
      margin-right: 0;
    }
  }
  .type {
    .title {
      font-size: 12px;
      color: #666666;
      font-weight: bold;
      margin-right: 10px;
    }
    .el-tag {
      margin-right: 10px;
    }
  }
}

.box-card {
  width: @width;
  margin: 0 auto 20px;
  .text {
    color: #222222;
    font-size: 14px;
  }
}

.divider {
  background-color: #333;
  margin: 16px 0;
}
.divider.mini {
  margin: 10px 0;
}

.comment-list {
  .item {
    display: flex;
    height: auto;
    margin: 20px;
    font-size: 16px;
    .avatar {
      width: 7%;
    }
    .info {
      width: 90%;
      .nickname {
        font-weight: bold;
        color: #54555c;
        height: 33%;
      }
      .content {
        min-height: 33%;
        font-size: 14px;
        color: #7f7f7f;
      }
      .createTime {
        padding-top: 10px;
        font-size: 12px;
        height: 33%;
      }
    }
    .delete {
      font-size: 12px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.material-upload {
  .title {
    color: #000000;
    font-weight: 700;
    margin-top: 10px;
  }
  .title:first-child {
    margin-top: -10px;
  }
  .item {
    display: inline-block;
    width: 33%;
    font-size: 12px;
    margin: 4px 0;
  }
}
.donate-title {
  margin-top: -60px;
  margin: -60px 0 40px 60px;
  font-size: 12px;
}

.donate-title2 {
  color: #616161;
  padding-bottom: 10px;
}

.checkbox {
  display: inline-block;
  width: 75px;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  margin-right: 18px;
  color: #666666;
  text-align: center;
  background: #ededed;
  transition: all 0.2s;
  user-select: none;
  cursor: pointer;
}
.checkbox:last-child {
  margin-right: 0;
}
.checkbox.checked {
  color: #ffffff;
  background: #ff464c;
  transition: all 0.2s;
}
.report-info {
  height: 30px;
  line-height: 30px;
  background: rgba(255, 106, 76, 0.12);
  margin-bottom: 30px;
  box-sizing: border-box;
  padding: 0 23px 0 10px;
  margin-top: 20px;
  .title {
    display: inline-block;
    color: #ff6a4c;
    vertical-align: bottom;
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>

<style lang="less">
.box-card {
  .el-textarea__inner {
    border: none;
  }
}
.video-list {
  .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
    white-space: nowrap;
    height: 104px;
  }
}
.group-dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.video-js {
  width: 900px !important;
  height: 506px !important;
}
</style>
